import qs from 'qs';

export const formatGoogleMapLink = (longitude: string, lattitude: string, placeId: string): string =>
  `https://www.google.com/maps/search/?api=1&query=${lattitude},${longitude}&query_place_id=${placeId}`;

export const formatGoogleMapLinkForAddress = (address: string): string => `https://maps.google.com/?${qs.stringify({ q: address })}`;
